import React from 'react';
import {SearchModalState} from './TorqueInvoiceSearch';
import AsyncSelect from 'react-select/async';
import {searchInvoices} from './functions';

type InvoiceAutocompleterProps = {
    pipeline: string;
    searchModalState: SearchModalState;
    setSearchModalState: any;
    title: string;
}

export const InvoiceAutocompleter: React.FunctionComponent<InvoiceAutocompleterProps> = ({
                                                                                             pipeline,
                                                                                             title,
                                                                                             searchModalState,
                                                                                             setSearchModalState
                                                                                         }): JSX.Element => {
    return (
        <div className="row">
            <div className="col-12 col-md-8 offset-md-2">
                <div className="d-flex">
                    <div className="flex-grow-1 mr-3">
                        <p className="mb-0"><strong>{title}</strong></p>
                        <AsyncSelect
                            placeholder={'Begin type Invoice# to auto-complete'}
                            loadOptions={searchInvoices(pipeline)}
                            isClearable={true}
                            isDisabled={searchModalState.isSearchingLines}
                            value={searchModalState.selectedInvoice}
                            onChange={(option: any, {action}) => {
                                if (action === 'select-option') {
                                    setSearchModalState((state: SearchModalState) => ({
                                        ...state,
                                        selectedInvoice: option
                                    }));
                                } else {
                                    setSearchModalState((state: SearchModalState) => ({
                                        ...state,
                                        selectedInvoice: option,
                                        selectedLines: [],
                                        lines: []
                                    }));
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}